/*******************************************************************************
CLEAR INJURY ARCHIVE SEARCH
Resets the player search input to its empty state.
*******************************************************************************/

import clearInputBox from '../../../js/universal/input-with-clear/clear';

export default function clearInjuryArchiveSearch() {
    const $input = $('#injury-archive-search');

    // Sets the last search to nothing
    $input.data('lastsearch', '');

    // Clears the search results
    $('.archive-search-results').empty();

    // Clear the input box and remove the clear button
    // This is normally handled by the universal input box with clear button scripts in the /universal/ folder,
    // but clearPlayerSearch() is triggered in other contexts, so it's necessary to call it manually here too
    clearInputBox($input);
}
